import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'stupa-map-options-drawer',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './map-options-drawer.component.html',
    styleUrl: './map-options-drawer.component.scss'
})
export class MapOptionsDrawerComponent {
    @Input() location: string = '';
    @Output() panelClose = new EventEmitter<void>();
    @Output() openMap = new EventEmitter<'google' | 'apple'>();

    onClose(event?: MouseEvent) {
        if (event) {
            event.stopPropagation();
        }
        this.panelClose.emit();
    }

    onOpenMap(type: 'google' | 'apple', event: MouseEvent) {
        event.stopPropagation();
        this.openMap.emit(type);
    }
}
